import { render } from "./NewEmployeeDetail.vue?vue&type=template&id=f3ae2660"
import script from "./NewEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./NewEmployeeDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__